export const VALIDATE_QUESTIONNAIRE_BLOCKS = 'VALIDATE_QUESTIONNAIRE_BLOCKS';

function validateBlocks(questionnaireType) {
  return {
    type: VALIDATE_QUESTIONNAIRE_BLOCKS,
    questionnaireType
  };
}

export function validateQuestionnaireBlocks(questionnaireType) {
  return (dispatch) => {
    dispatch(validateBlocks(questionnaireType));
  };
}
